import { render, staticRenderFns } from "./idolTechnicalServiceFeeList.vue?vue&type=template&id=d5dd3b4c&scoped=true"
import script from "./idolTechnicalServiceFeeList.vue?vue&type=script&lang=ts"
export * from "./idolTechnicalServiceFeeList.vue?vue&type=script&lang=ts"
import style0 from "./idolTechnicalServiceFeeList.vue?vue&type=style&index=0&id=d5dd3b4c&prod&lang=stylus&scoped=true"
import style1 from "./idolTechnicalServiceFeeList.vue?vue&type=style&index=1&id=d5dd3b4c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dd3b4c",
  null
  
)

export default component.exports